import { messagingSocket } from '../../components/js/modules/Socket';

export const invoke = (eventName, ...args) => {
    return new Promise((resolve, _) => {
        messagingSocket.emit("emitPortal", eventName, args, resolve);
    });
}